import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params, Router, RouterStateSnapshot } from '@angular/router';
import { ApplicationPathConstants } from '@ddt-web/config';
import { LocaleUtilResolverService } from '@ddt-web/config-layer';
import * as cloneDeep from 'lodash/cloneDeep';

import { Countries } from '../enums';

@Injectable({
	providedIn: 'root'
})
export class MeLocaleRouteGuard implements CanActivate {
	constructor(
		private router: Router,
		private localeUtilResolverService: LocaleUtilResolverService
	) { }

	public canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const queryParams: Params = cloneDeep(childRoute.queryParams);
		const routeLocale = queryParams?.['locale'];

		const locale = routeLocale || this.localeUtilResolverService.getResolvedLocaleValue();

		if (locale !== Countries['US'].toLowerCase()) {
			this.router.navigate([`/${ApplicationPathConstants.MODELS_EXPERIENCE_PATHS.FIND_AND_COMPARE}`], { queryParams });
			return false;
		}
		return true;
	}
}
